import { computed } from 'vue';
import { useStore } from 'vue-livestore';
import { tables, events } from '@/livestore/schema.js';

export function useNotifications() {
  const { store } = useStore();

  const all = computed(() => store.query(tables.notifications.select()));
  const unread = computed(() => all.value.filter(n => !n.read));
  const unreadCount = computed(() => unread.value.length);

  function notify(params: {
    actionTab?: string | null;
    body: string;
    title: string;
    type?: string;
  }) {
    const now = Date.now();
    store.commit(
      events.notificationCreated({
        action_tab: params.actionTab ?? null,
        body: params.body,
        created_at: now,
        id: crypto.randomUUID(),
        read: 0,
        title: params.title,
        type: params.type ?? 'info',
      }),
    );
  }

  function markRead(id: string) {
    store.commit(events.notificationRead({ id }));
  }

  function dismiss(id: string) {
    store.commit(events.notificationDismissed({ id }));
  }

  // Matches by title, not `type` — `type` is a visual severity shared across different kinds
  // of notification (e.g. both the past-due and invoice-limit notifications are 'warning'), so
  // it can never actually distinguish which specific notification is already unresolved.
  function hasUnresolved(title: string): boolean {
    return all.value.some(n => n.title === title && !n.read);
  }

  return { all, dismiss, hasUnresolved, markRead, notify, unread, unreadCount };
}
